import Button from '@rio-cloud/rio-uikit/Button';
import { JSX } from 'react';
import { FormattedMessage } from 'react-intl';
import { ActionButtonConfig } from '../../sharedComponents/common.types';
import { ServiceType } from '../shared/commonServiceOrder.types';
import { AccessoryType, CollectedAccessories } from './accessory.types';
import { ServiceOrderStatus } from './serviceOrder.types';

export const getServiceNameByType = (serviceType: ServiceType): JSX.Element => {
    return <FormattedMessage id={`outboundPortal.serviceOrder.serviceName.${serviceType}`} />;
};

export const getObjectKeyForAccessory = (accessory: AccessoryType): keyof CollectedAccessories => {
    switch (accessory) {
        case AccessoryType.KEY:
            return 'key';
        case AccessoryType.MANUAL:
            return 'manual';
        case AccessoryType.LICENSE_PLATE:
            return 'licensePlate';
        case AccessoryType.SERVICE_SCHEDULE:
            return 'serviceSchedule';
        case AccessoryType.SUMMER_WHEELS:
            return 'summerWheels';
        case AccessoryType.WINTER_WHEELS:
            return 'winterWheels';
        case AccessoryType.VEHICLE_REGISTRATION_DOCUMENT:
            return 'vehicleRegistrationDocument';
    }
};

export const serviceOrderArchiveButtonConfig: ActionButtonConfig = {
    labelId: 'outboundPortal.serviceOrder.button.archive',
    style: Button.DANGER,
    className: 'btn-outline',
    icon: 'rioglyph rioglyph-folder-closed text-size-400pct',
    expandSidebar: false,
    isSpinnerInverse: true,
};

export const serviceOrderEditButtonConfig: ActionButtonConfig = {
    labelId: 'outboundPortal.serviceOrder.button.edit',
    style: Button.PRIMARY,
    icon: 'rioglyph rioglyph-pencil text-size-400pct',
    expandSidebar: true,
    isSpinnerInverse: false,
};

export const getServiceOrderTableActionButtonConfig = (
    status: ServiceOrderStatus,
    isFinalized: boolean,
): ActionButtonConfig => {
    if (isFinalized) {
        return serviceOrderArchiveButtonConfig;
    }
    switch (status) {
        case ServiceOrderStatus.OPEN:
        case ServiceOrderStatus.COMPLETED:
            return serviceOrderEditButtonConfig;
        case ServiceOrderStatus.CANCELLED:
            return serviceOrderArchiveButtonConfig;
    }
};
